import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';
import { useTranslation } from 'react-i18next';

const usePartnerLoginDialogue = (response?: {
  success: boolean;
  errorMessage?: string;
}): { showDialogue: () => void } => {
  const errorMessage: string = response?.errorMessage || '';
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UsePartnerLoginPasswordDialogue' });

  const history = useHistory();
  const { provideProps, showDialogue } = useConfirmationDialogue();

  const messageMap: { [key: string]: string } = {
    'Invalid Password!': 'The old password that has been provided is not correct.',
  };

  useEffect(() => {
    const handlers = {
      success: () => {
        provideProps({
          title: t('Success.title'),
          subTitle: t('Success.subTitle'),
          status: 'success',
          confirm: {
            label: t('Success.confirmButton'),
            action: () => {
              history.push('/dashboard');
            },
          },
          cancel: {
            label: t('Success.cancelButton'),
            action: () => {},
          },
        });
      },
      errorMessage: () => {
        provideProps({
          title: t('Error.title'),
          subTitle: messageMap[errorMessage] || errorMessage,
          status: 'error',
          confirm: {
            label: t('Error.confirmButton'),
            action: () => {
              history.push('/dashboard');
            },
          },
          cancel: {
            label: t('Error.cancelButton'),
            action: () => {},
          },
        });
      },
    };

    if (errorMessage) return handlers.errorMessage();

    return handlers.success();
  }, [response, errorMessage]);

  return { showDialogue };
};

export default usePartnerLoginDialogue;
